export default "__VITE_ASSET__9162c528__"